export const PAYMENT_SCHEDULE_CREATE_MODAL_MATCH =
  "/debts/:debt_id/payment_schedules/new"
export const PAYMENT_SCHEDULE_VIEW_MODAL_MATCH =
  "/debts/:debt_id/payment_schedules/:id"
export const PAYMENT_SCHEDULE_SIGN_MODAL_MATCH =
  "/debts/:debt_id/payment_schedules/:id/sign"
export const PAYMENT_SCHEDULE_PROMISE_MODAL_MATCH =
  "/debts/:debt_id/payment_schedules/:id/promise"
export const PAYMENT_SCHEDULE_FALLBACK_MATCH =
  "/:locale/client/sign_payment_schedules/:id"

export const PAYMENT_SCHEDULE_SIGN_ACTION = "sign"
export const PAYMENT_SCHEDULE_PROMISE_ACTION = "promise"

export const PAYMENT_SCHEDULE_SIGN_STATUS_DONE = "success"

export const PS_CREATE_STEP_INITIAL = 0
export const PS_CREATE_STEP_CHOOSE_SUBSCRIPTION = 1
export const PS_CREATE_STEP_CHOOSE_PAYMENT_METHOD = 2
export const PS_CREATE_STEP_CHOOSE_START_DATE = 3
export const PS_CREATE_STEP_FAILURE = 4

export const PS_SIGN_STEP_INITIAL = 0
export const PS_SIGN_STEP_CHOOSE_PROVIDERS = 1
export const PS_SIGN_STEP_SMART_ID = 2
export const PS_SIGN_STEP_MOBILE_ID = 3
export const PS_SIGN_STEP_ID_CARD = 4
export const PS_SIGN_STEP_NPS = 5
export const PS_SIGN_STEP_NPS_SUCCESS = 6
export const PS_SIGN_STEP_FINAL = 7

export const PS_PROMISE_STEP_INITIAL = 0
export const PS_PROMISE_STEP_SIMPLE_SIGN = 1
export const PS_PROMISE_STEP_NPS = 2
export const PS_PROMISE_STEP_NPS_SUCCESS = 3
export const PS_PROMISE_STEP_FINAL = 4

export const PAYMENT_SCHEDULE_AMOUNT_OPTIONS = {
  min: 30,
  step: 10,
}

export const PAYMENT_SCHEDULE_PERIOD_OPTIONS = {
  min: 1,
  max: 36,
  step: 1,
}

export const PAYMENT_SCHEDULE_STANDARD_PERIOD_OPTIONS = {
  min: 1,
  max: 12,
  middle: 6,
  step: 1,
}

export const PAYMENT_SCHEDULE_SILVER_PERIOD_OPTIONS = {
  min: 1,
  max: 24,
  middle: 12,
  step: 1,
}

export const PAYMENT_SCHEDULE_GOLD_PERIOD_OPTIONS = {
  min: 1,
  max: 36,
  middle: 18,
  step: 1,
}
